import { Manager, type Socket } from 'socket.io-client'

const options = {
  autoConnect: false,
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 10000,
  reconnectionAttempts: 3,
  timeout: 20000,
  transports: ['websocket'],
}

const manager: Manager = new Manager(
  import.meta.env.VITE_SYNC_SOCKET_URL,
  options
)

const socket: Socket = manager.socket('/', {})

export { socket }
